<template>
  <el-button
    :disabled="disabled"
    :class="[
      { 'is-transparent': transparent === true },
      { 'is-radius': radius === true },
      { 'is-fit': fit === true },
      { 'is-white': white === true },
      { 'is-disabled': disabled === true },
    ]"
  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: "MiddleButton",
  props: {
    transparent: {
      type: Boolean,
      default: false,
    },
    radius: {
      type: Boolean,
      default: false,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang='scss' scoped>
.el-button {
  @include flex-center;
  color: $white;
  background: $green-color;
  border-radius: 5px;
  border: unset;
  font-size: 16px;
  font-weight: 300;
  width: 180px;
  height: 48px;
  @include transition;
  &:hover, &:focus {
    opacity: 0.9;
    color: $white;
    background: $green-color;
    @include transition;
  }
  &.is-transparent {
    color: $main;
    background: transparent;
    border: 1px solid $gray-color;
    &:hover, &:focus {
      opacity: 1;
      border: 1px solid $main;
    }
  }
  &.is-radius {
    border-radius: 40px;
  }
  &.is-fit {
    width: auto;
    padding: 8px 25px;
  }
  &.is-disabled {
    background: $bone-color;
  }
  &.is-white {
    border: 1px solid $white-color;
    background: transparent;
    color: $white;
    @include transition;
    &:hover, &:focus {
      color: $main;
      background: $white;
      border: 1px solid $white;
      @include transition;
    }
  }
}
</style>